export default __webpack_public_path__ + "static/footer-bg-five-52461d0a38c2d61a0ab58b2aa76896ca.jpg";